// extracted by mini-css-extract-plugin
export default {"btn":"ImgSelectModal_btn__j2HSQ"};